import BaseServiceHttp from '../baseService'
class StatusPostagens extends BaseServiceHttp {
  constructor(id) {
    const resource = 'status-postagens'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new StatusPostagens(id)
